import { render, staticRenderFns } from "./ChildrenDependantsMortgage.vue?vue&type=template&id=192209c2"
import script from "./ChildrenDependantsMortgage.vue?vue&type=script&lang=js"
export * from "./ChildrenDependantsMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports